import { Link } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { IUomConversionAuditRow } from 'companySettings/types';
import { PartNumberHelper } from 'parts/helpers';
import { Level } from 'theme/enums';

interface IProps extends ICellRendererParams<IUomConversionAuditRow> {
  onPartClick?: (row: IUomConversionAuditRow) => void;
}

export const PartNumberCell = ({ data, value, onPartClick }: IProps) => {
  // Group row: show the group key the column provides.
  if (!data) {
    return value ?? null;
  }

  // The part-details panel resolves the part by number + manufacturer; rows
  // without a resolvable manufacturer stay plain text.
  const label = PartNumberHelper.toLabel(data.partNumber);

  if (!onPartClick || !data.manufacturerUrlName) {
    return label;
  }

  return (
    <Link component="button" level={Level.BODY_SM} onClick={() => onPartClick(data)}>
      {label}
    </Link>
  );
};
